import React from 'react'
import { Inline } from '@/components/shared/atoms/layout/Inline'
import { PaginationButton } from '@/components/frontend/atoms/navigation/PaginationButton'
import type { BlogPagination as BlogPaginationType } from '@/types/frontend'

interface BlogPaginationProps {
  pagination: BlogPaginationType
  basePath: string
  activeTag?: string | null
  search?: string
}

function buildHref(basePath: string, page: number, tag?: string | null, search?: string): string {
  const params = new URLSearchParams()
  if (page > 1) params.set('page', String(page))
  if (tag) params.set('tag', tag)
  if (search) params.set('search', search)
  const qs = params.toString()
  return qs ? basePath + '?' + qs : basePath
}

export const BlogPagination: React.FC<BlogPaginationProps> = ({
  pagination, basePath, activeTag, search,
}) => {
  const { currentPage, totalPages } = pagination
  if (totalPages <= 1) return null

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1)

  return (
    <Inline gap="0" justify="center">
      <PaginationButton href={buildHref(basePath, currentPage - 1, activeTag, search)} disabled={currentPage <= 1}>
        &laquo;
      </PaginationButton>
      {pages.map((page) => (
        <PaginationButton key={page} href={buildHref(basePath, page, activeTag, search)} active={page === currentPage}>
          {page}
        </PaginationButton>
      ))}
      <PaginationButton href={buildHref(basePath, currentPage + 1, activeTag, search)} disabled={currentPage >= totalPages}>
        &raquo;
      </PaginationButton>
    </Inline>
  )
}
